/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youraccounthasbeensuccessfullycreatedyouwillberedirected9Inputs */

const en_youraccounthasbeensuccessfullycreatedyouwillberedirected9 = /** @type {(inputs: Youraccounthasbeensuccessfullycreatedyouwillberedirected9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account has been successfully created. You will be redirected...`)
};

const de_youraccounthasbeensuccessfullycreatedyouwillberedirected9 = /** @type {(inputs: Youraccounthasbeensuccessfullycreatedyouwillberedirected9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Konto ist erstellt. Du wirst weitergeleitet…`)
};

/**
* | output |
* | --- |
* | "Your account has been successfully created. You will be redirected..." |
*
* @param {Youraccounthasbeensuccessfullycreatedyouwillberedirected9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const youraccounthasbeensuccessfullycreatedyouwillberedirected9 = /** @type {((inputs?: Youraccounthasbeensuccessfullycreatedyouwillberedirected9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youraccounthasbeensuccessfullycreatedyouwillberedirected9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youraccounthasbeensuccessfullycreatedyouwillberedirected9(inputs)
	return de_youraccounthasbeensuccessfullycreatedyouwillberedirected9(inputs)
});
export { youraccounthasbeensuccessfullycreatedyouwillberedirected9 as "yourAccountHasBeenSuccessfullyCreatedYouWillBeRedirected" }